<template>
    <section class="client-summary" aria-label="Resumen del cliente" :aria-busy="loading">
        <v-btn
            icon="mdi-arrow-left"
            variant="text"
            size="small"
            aria-label="Volver"
            title="Volver"
            @click="$emit('back')"
        />
        <div class="summary-item">
            <span class="summary-label">{{ ui?.managements?.informacionGeneral?.id_cliente || 'ID Cliente' }}:</span>
            {{ client.id_cliente }}
        </div>
        <div class="summary-item">
            <span class="summary-label">Cliente:</span> {{ client.nombre }}
        </div>
        <div class="summary-item">
            <span class="summary-label">{{ ui?.managements?.pago?.saldo || 'Saldo' }}:</span>
            {{ balance }}
        </div>
        <div class="summary-item">
            <span class="summary-label">Última Cambio:</span>
            <ManagementDate :value="client.management_data_changed_at" />
        </div>
        <div class="summary-item">
            <span class="summary-label">Última Carga:</span>
            <ManagementDate :value="client.managed_at" kind="processed" />
        </div>
        <div class="summary-item">
            <span class="summary-label">Estado:</span>
            <span :class="statusClass">{{ client.estado }}</span>
        </div>
    </section>
</template>

<script>
import ManagementDate from './ManagementDate.vue'

export default {
    name: 'ClientSummary',
    components: { ManagementDate },
    emits: ['back'],
    props: {
        loading: { type: Boolean, default: false },
        client: { type: Object, required: true },
        ui: { type: Object, default: () => ({}) },
        balance: { type: [String, Number], default: '' },
        statusClass: { type: String, default: '' },
    },
}
</script>

<style scoped>
.client-summary {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 20px;
    width: 100%;
    min-height: 50px;
    padding: 8px 12px;
    border-bottom: 1px solid #E3E3E3;
    font-size: 10pt;
}
.summary-item {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1 1 auto;
    gap: 4px;
}
.summary-label {
    font-weight: 600;
    white-space: nowrap;
}
</style>
